<template lang="pug">
#modal-visualizar-detalhes-alerta-socioambiental
    el-dialog.custom-dialog(
        :visible.sync='show',
        :close-on-click-modal='false',
        :close-on-press-escape='false',
        :destroy-on-close='true',
        :show-close='true',
        width='45%'
    )
        template(slot='title')
            .dialog-header
                | {{ $t('mensagens.visualizarDetalhesAlertas.header') }}

            p.title
                | {{ $t('mensagens.visualizarDetalhesAlertas.titulo') }}
            el-radio-group.radio-group-container(
                v-model='radio',
                @change='buscarAlertaSocioambiental'
            )
                el-radio.radio-spacing(:label='"hoje"')
                    | {{ $t('mensagens.blocoAlerta.filtros.hoje') }}
                el-radio.radio-spacing(:label='"seteDias"')
                    | {{ $t('mensagens.blocoAlerta.filtros.seteDias') }}
                el-radio.radio-spacing(:label='"trintaDias"')
                    | {{ $t('mensagens.blocoAlerta.filtros.trintaDias') }}
                el-radio.radio-spacing(:label='"todoPeriodo"')
                    | {{ $t('mensagens.blocoAlerta.filtros.todoPeriodo') }}

        .empty(v-if='dados.length < 1')
            el-empty(
                :description="$t('mensagens.visualizarDetalhesAlertas.descricao')"
            )
        #timeline-historico-monitoramento-socioambiental.content(v-else)
            p.title-items
                | {{ $t('mensagens.visualizarDetalhesAlertas.selecionarTerritorio') }}
            el-timeline
                el-timeline-item(
                    v-for='(dado, index) in dados',
                    :key='index',
                    color='transparent',
                    size='large'
                )
                    .time-line-box
                        .time-line-box--texto
                            p.titulo(
                                @click='visualizarTerritorioMonitorado(dado.id)'
                            ) {{ dado.nomeTerritorio }}
                        .time-line-box--acoes(v-if='true')
                            .buttons
                                .mdi.mdi-loading.mdi-36px.mdi-spin.loading-pdf(
                                    v-if='dado.loading'
                                )
                                BaseButton.button-arrow(
                                    icon='el-icon-arrow-right',
                                    @click='visualizarTerritorioMonitorado(dado.id)'
                                )
        el-divider.custom-divider_
        footer(slot='footer')
            BaseButton.margin-top(
                @click='fecharModalAlertaDetalhes()',
                size='big',
                type='primary'
            )
                | {{ $t('mensagens.comuns.voltar') }}
</template>

<script>
import MonitoramentoSocioambientalService from '@/services/MonitoramentoSocioambientalService';
import TimelineHistoricoMonitoramento from '@/components/monitoramento/TimelineHistoricoMonitoramento';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'ModalVisualizarDetalhesAlertaSocioambiental',

    components: {
        TimelineHistoricoMonitoramento,
        BaseButton
    },

    props: {
        show: {
            type: Boolean,
            required: true
        },
        periodo: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            isLoading: false,
            radio: 'hoje',
            dados: [],
            filtro: 'totalTrimestral'
        };
    },

    watch: {
        periodo: {
            handler() {
                this.radio = this.periodo;
            },
            immediate: true
        },
        show: {
            handler() {
                if (this.show) {
                    this.buscarAlertaSocioambiental();
                }
            },
            immediate: true
        }
    },

    methods: {
        fecharModalAlertaDetalhes() {
            this.radio = this.periodo;
            this.$emit('voltar');
        },

        visualizarTerritorioMonitorado(id) {
            this.$router.push({
                name: 'VisualizarMonitoramentoSocioambiental',
                params: { idAreaMonitorada: id }
            });
        },

        async buscarAlertaSocioambiental() {
            this.isLoading = true;

            switch (this.radio) {
                case 'hoje':
                    this.filtro = 'totalDiario';
                    break;
                case 'seteDias':
                    this.filtro = 'totalSemanal';
                    break;
                case 'trintaDias':
                    this.filtro = 'totalMensal';
                    break;
                case 'todoPeriodo':
                    this.filtro = 'total';
                    break;
            }

            try {
                const { data } =
                    await MonitoramentoSocioambientalService.buscarAlertasAreasMonitoradasSocioambiental(
                        this.filtro
                    );
                this.dados = data;
            } catch (error) {
                this.$notify.error(
                    'Não foi possivel carregar os dados detalhados de alertas.'
                );
            } finally {
                this.isLoading = false;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
#modal-visualizar-detalhes-alerta-socioambiental {
    ::v-deep .el-dialog__body {
        padding: 0px;
    }

    .content {
        overflow: auto;
        max-height: 330px;
    }

    .margin-top {
        margin-top: 16px;
    }

    .margin-left {
        margin-left: 20px;
    }

    .custom-cursor {
        cursor: pointer;
    }

    .alert-container {
        line-height: 1rem;
    }

    .alert-footer {
        display: flex;
    }

    .footer-label {
        font-family: 'Roboto', 'sans serif';
        color: #00413c;
        font-weight: 500;
        margin-right: 5px;
        font-size: 13.5px;
    }

    .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        border-color: blue !important;
        background-color: blue !important;
    }

    .el-radio-button__orig-radio:checked + .el-radio-button__inner::after {
        border-color: blue !important;
        background-color: blue !important;
    }

    .custom-expanded-table {
        margin-top: -20px;
    }

    .custom-divider_ {
        margin-bottom: -10px;
        margin-top: 5px;
    }

    .custom-icon {
        margin-right: 9px;
        vertical-align: middle;
        filter: brightness(0) invert(1);
    }

    .radio-group-container {
        max-width: 510px;
        height: 10px;
        display: flex;
        justify-content: space-between;
    }

    .custom-buttom:hover .custom-icon {
        filter: none;
    }

    .lyra-icon {
        cursor: pointer;
    }

    .menu-description {
        font-weight: 400;
        font-size: 16px;
        font-family: 'Roboto', 'sans serif';
    }

    .radio-spacing {
        margin-right: 10px;
    }

    .dialog-header {
        background-color: #e9e9e9;
        color: #00413c;
        padding: 15px;
        margin: -20px -20px 20px -20px;
        font-size: 18px;
        font-weight: 600;
        border-radius: 5px, 5px, 0px, 0px;
        box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.2);
    }

    .custom-dialog {
        border-radius: 5px;
    }

    footer {
        display: flex;
        justify-content: flex-end;
    }

    .c-pagination {
        text-align: center;
        margin-top: 30px;
    }

    .view-title {
        margin-left: 15px;
        font-family: 'Roboto', 'sans serif';
        font-size: 16px;
        font-weight: 500;
    }

    .title {
        font-family: 'Roboto', 'sans serif';
        color: #00413c;
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        letter-spacing: 0em;
        text-align: left;
    }
    .title-items {
        font-family: 'Roboto', 'sans serif';
        color: #3b3b3b;
        font-weight: 500;
        font-size: 15px;
        line-height: 16px;
    }

    .alert-title {
        font-family: 'Roboto', 'sans serif';
        color: #00413c;
        font-weight: 500;
        margin-top: 35px;
    }

    .alert-description {
        font-family: 'Roboto', 'sans serif';
        color: #000000;
        font-weight: 300;
    }

    .el-table {
        .el-table__expand-icon {
            height: 24px;
            width: 24px;
            margin-bottom: 10px;
        }

        .el-table__expand-icon > .el-icon {
            color: #3b3b3b;
            font-weight: 700;
            font-size: 16px;
        }

        thead {
            color: var(--primary);
            font-size: 16px;
            font-weight: 500;
            line-height: 18.75px;
        }

        .el-descriptions-row {
            .el-descriptions-item__label {
                color: var(--primary);
                font-weight: 500;
                font-size: 16px;
                line-height: 18.75px;
            }
        }

        .el-descriptions-item__label.has-colon::after {
            content: '';
        }
    }
}
#timeline-historico-monitoramento-socioambiental {
    margin-top: 25px;
    padding: 0 20px;
    .el-timeline {
        padding-left: 0px !important;
        .el-timeline-item {
            padding-bottom: 0px;
            .el-timeline-item__node {
                top: 25px;
            }
            .el-timeline-item__wrapper {
                .el-timeline-item__content {
                    height: 52px;
                }
                .time-line-box {
                    background: var(--white);
                    border: 1px solid var(--default-background-color);
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    height: 52px;

                    .time-line-box--texto {
                        padding: 10px 7px;
                        p {
                            &.titulo {
                                margin: 0;
                                padding-top: 0;
                                padding-bottom: 0;
                                font-weight: 600;
                                color: #3b3b3b;
                                cursor: pointer;
                            }
                            &.subtitulo {
                                margin: 0;
                                color: var(--primary);
                                font-size: 12px;
                            }
                        }
                    }
                    .time-line-box--acoes {
                        padding-left: 5px;
                        background-color: var(--white);
                        align-items: center;
                        color: (--black);
                        height: 50px;
                        .buttons {
                            display: flex;
                            height: 100%;

                            .button-arrow {
                                padding: 12px 5px;
                                margin-left: 5px;
                            }
                            .el-button {
                                background: #f3f3f3;
                                border-radius: 0px;
                                border-color: transparent;
                                &:hover {
                                    background: var(--secondary);
                                }
                            }
                            .el-button.is-disabled {
                                color: #3b3b3b;
                            }

                            .loading-pdf {
                                background: #f3f3f3;
                                padding: 7px 20px;
                            }
                        }
                    }
                }
                .alerta {
                    background: var(--primary);
                }
            }
            .el-timeline-item__tail {
                border-left: 2px solid #d1cece !important;
                top: 35px;
            }
        }
    }
}
</style>
<style lang="scss">
#timeline-historico-monitoramento-socioambiental
    > ul
    > li
    > div.el-timeline-item__wrapper {
    top: 2px;
    padding-left: 0px;
    .el-timeline-item__content {
        height: 52px;
    }
}
</style>
